import axios from 'axios';
import Swal from 'sweetalert2';

import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
import socket from '../tools/socke';

const Usuario = ObtieneDatosCookies();

const anulaAsignacionDocente = async (datos) => {
  const realizaCambios = async (viejaAnulada) => {
    const fechaHoy = new Date();
    const year = fechaHoy.getFullYear();
    const month = String(fechaHoy.getMonth() + 1).padStart(2, '0');
    const day = String(fechaHoy.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    return Swal.fire({
      title: "Indique en qué fecha fue el cese del Cargo",
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      html: `
        <input
          type="date"
          value="${formattedDate}"
          min="${viejaAnulada.fechaInicio}"
          max="${formattedDate}"
          class="swal2-input"
          id="range-value">
      `,
    }).then((result) => {
      if (result.isConfirmed || !result.isDismissed) {
        const fechaSeleccionada = result.isConfirmed ? document.getElementById('range-value').value : formattedDate;
        return continuo(fechaSeleccionada, viejaAnulada);
      }
      return false;
    });
  };

  const continuo = async (fecha, viejaAnulada) => {
    const viejaAsignacionMateriaDatos = {
      fechaFinalizacion: fecha,
      usuarioID: Usuario.id,
      sedeID: Usuario.sedeID,
      dependenciaID: Usuario.destino,
      estado: "Anulada",
    };

    const clienteAnulado = axios.create({
      baseURL: process.env.REACT_APP_BASEURL + "docentes/anulaAsignacion",
    });

    try {
      const anulacion = await clienteAnulado.post('/' + viejaAnulada.id, viejaAsignacionMateriaDatos);
      if (anulacion) {
          socket.emit("ofreciHoras",{ dato: viejaAnulada })
        const clientLog = axios.create({
          baseURL: process.env.REACT_APP_BASEURL + "docentes/creaLogCambioDocente/",
        });

        const log = {
          fechaCambio: fecha,
          usuarioCambio: Usuario.id,
          docenteInicial: viejaAnulada.docenteDni,
          docenteFinal: -1,
          idAsignaInicial: viejaAnulada.id,
          idAsignaRemplazo: -1,
          fechaInicialMateria: viejaAnulada.fechaInicio,
          fechaFinalMateria: fecha,
        };

        const creaLog = await clientLog.post('/', log);

        if (creaLog) {
          Swal.fire({
            text: "Anulación del Cargo Docente",
            title: "Cambio realizado correctamente",
            icon: "success",
            timer: 4000,
          });
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error("Error al anular la asignación:", error);
      return false;
    }
  };

  try {
    const client = axios.create({
      baseURL: process.env.REACT_APP_BASEURL + "docentes/devuelveIdAsignacion/",
    });

    const datosRecuperados = await client.post('/' + datos.materiaAsignadaId);

    if (datosRecuperados) {
      const inforMateria = datosRecuperados.data.respuesta[0];
      const resultado = await realizaCambios(inforMateria);
      return resultado;
    }
    return false;
  } catch (error) {
    console.error("Error al recuperar la asignación:", error);
    return false;
  }
};

export default anulaAsignacionDocente;
